import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  dateTimeText: {
    color: token.colorTextDescription,
    whiteSpace: 'nowrap'
  },
  dateTimeTextSecondary: {
    color: token.colorTextSecondary,
    whiteSpace: 'nowrap'
  }
}))
